export default "<div class=\"blue\">\n  <div class=\"white\">\n    <app-configuration-list></app-configuration-list>\n  </div>\n</div>\n";